module.exports = "<img (click)=\"clickBack()\"  animateOnScroll class=\"btn-back\"  src=\"../../assets/img/btn.png\"/>\n"